<template lang="pug">
  v-layout(align-start)
    v-flex
      v-data-table.elevation-1(:headers='headers' item-key='ordenes' :items='ordenes' :search='search' sort-by='fechaEmision' :loading='loading' loading-text='Cargando, por favor espere...')
        template(v-slot:top)
          v-toolbar(flat color='primary' dark)
            v-toolbar-title Ordenes de Cotización
            v-divider.mx-4(inset vertical)
            v-spacer
            v-text-field.text-xs-center(v-model='search' label='Búsqueda' single-line hide-details color='success')
            v-spacer
            v-dialog(v-model='dialog' scrollable persistent max-width='80%')
              template(v-slot:activator='{ on }')
                v-btn.mx-2(v-if='validarCrear()' fab dark small color='success' v-on='on')
                  v-icon(dark) mdi-plus
              v-card(v-if='editedIndex !== -1')
                template
                  v-card
                    v-toolbar(flat='' color='primary' dark='')
                      v-toolbar-title {{ formTitle }}
                    v-tabs(vertical='')
                      v-tab
                        v-icon(left='') mdi-newspaper-plus
                        |         Orden
                      v-tab
                        v-icon(left='') mdi-clipboard-list-outline
                        |         Cotizaciones
                      v-tab-item
                        v-card(flat='')
                          v-card-text
                            HijoOrdenesDeCotizaciones(:productos='editedItem.productos' :productosSelec='editedItem.selecProductosHijo' :readHijo='read' :agregar='edicion')
                      v-tab-item
                        v-card(flat='')
                          v-card-text
                            v-flex(xs12)
                              v-layout(wrap='')
                                v-flex(xs4 style='padding:5px')
                                  v-select(dense outlined v-model='prod' :items="prodArray" label='Filtrar por producto')
                                v-flex(xs4 style='padding:5px')
                                  v-select(dense outlined v-model='diac' :items="diaArray" label='Filtrar por día de crédito')
                                v-flex(xs4 style='padding:5px')
                                  v-select(dense outlined v-model='diad' :items="diaArray" label='Filtrar por día de despacho')
                            v-flex(xs12 v-if='seleccion && seleccion.length > 0')
                              v-card(v-for='(item, i) in seleccion' :key='i', style='margin-bottom:10px')
                                v-toolbar#toolbar(flat='' color='primary' dark='' style='height: 40px;text-align: center;')
                                  v-toolbar-title(style='height: 40px;width: 100%;')
                                    v-flex(xs12)
                                      v-layout(wrap='' style='width: 100%;')
                                        v-flex(xs4)
                                          span(style='text-transform: capitalize;') Proveedor: {{item.idProveedor.nombre}}
                                        v-flex(xs4)
                                          span Días de Crédito: {{item.diaCredito}}
                                        v-flex(xs4)
                                          span Días de Despacho: {{item.diaDespacho}}
                                v-card-text(style='text-align: center;color: #464646;padding:0px')
                                  v-flex(xs12 style='border-bottom: 1px solid grey;')
                                    v-layout(wrap='')
                                      v-flex(xs4)
                                        span PRODUCTO
                                      v-flex(xs4)
                                        span CANTIDAD
                                      v-flex(xs4)
                                        span COSTO
                                  v-flex(xs12 v-for='(item2, i) in item.productos', :key='i')
                                    v-layout(wrap='')
                                      v-flex(xs4)
                                        span {{item2.idProducto.descripcion}}
                                      v-flex(xs4)
                                        span {{item2.cantidad}}
                                      v-flex(xs4)
                                        span {{item2.costo}}
                v-card-actions
                  v-spacer
                  v-btn(color='error' small dark @click='close')
                    v-icon mdi-close
                    | Cancelar
              v-card(v-else)
                template
                  v-card
                    v-toolbar(flat='' color='primary' dark='')
                      v-toolbar-title {{ formTitle }}
                    v-card-text
                      HijoOrdenesDeCotizaciones(:productos='editedItem.productos' :productosSelec='editedItem.selecProductosHijo' :readHijo='read' :agregar='edicion')
                v-card-actions
                  v-spacer
                  v-btn(color='error' small dark @click='close')
                    v-icon mdi-close
                    | Cancelar
                  v-btn(color='success' small dark @click='save')
                    v-icon mdi-content-save
                    | Guardar
        template(v-slot:item.action='{ item }')
          v-tooltip(bottom='')
            template(v-slot:activator='{ on }')
              v-icon.mr-2(color='primary_2' @click='editItem(item,true)' v-on="on") mdi-eye
            | Visualizar
          v-tooltip(bottom='')
            template(v-slot:activator='{ on }')
              v-icon(v-if='validarEliminar()' color='error' @click='deleteItem(item)' v-on="on") mdi-delete
            | Eliminar
        //-   v-tooltip(bottom='')
        //-     template(v-slot:activator='{ on }')
        //-       v-icon.mr-2(v-if='validarModificar() && item.estatus !== "cerrada"' color='warning' @click='editItem(item,false)' v-on="on") mdi-pencil
        //-     | Editar
        template(v-slot:no-data)
          h1 No hay ordenes de cotizaciones registradas
</template>

<script>
import Api from '@/services/methods'
import HijoOrdenesDeCotizaciones from '../components/HijoOrdenesDeCotizaciones'
import ProveedorM from '../components/modals/ProveedorM'
export default {
  data: () => ({
    dialog: false,
    read: false,
    emp: false,
    loading: true,
    diac: '',
    diad: '',
    prod: '',
    prodArray: [],
    diaArray: [
      {
        value: 1,
        text: 'Ascendente'
      },
      {
        value: 2,
        text: 'Descendente'
      }
    ],
    headers: [
      { text: 'Fecha de emision', value: 'fechaEmision', align: 'center' },
      { text: 'Cotizaciones', value: 'cotizaciones' },
      { text: 'Estatus', value: 'estatus', align: 'center' },
      { text: 'Acciones', value: 'action', align: 'right', sortable: false }
    ],
    search: '',
    permisosRuta: {},
    seleccion: {},
    seleccionres: {},
    ordenes: [],
    edicion: false,
    idProveedoresArray: [],
    proveedores: [],
    editedIndex: -1,
    editedItem: {
      productos: [],
      selecProductosHijo: [],
      idUsuario: ''
    },
    defaultItem: {
      productos: [],
      selecProductosHijo: [],
      idUsuario: ''
    }
  }),

  components: {
    HijoOrdenesDeCotizaciones,
    ProveedorM
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1
        ? 'Nuevo Orden de Compra'
        : this.read
          ? 'Informacion de la Orden de Compra'
          : 'Modificar Orden de Compra'
    }
  },

  watch: {
    prod (val) {
      if (val) {
        this.seleccion = []
        this.diad = ''
        this.diac = ''
        if (val === 1) {
          for (let i = 0; i < this.seleccionres.length; i++) {
            this.seleccion.push(this.seleccionres[i])
          }
        } else {
          for (let i = 0; i < this.seleccionres.length; i++) {
            for (let j = 0; j < this.seleccionres[i].productos.length; j++) {
              if (val === this.seleccionres[i].productos[j].idProducto._id) {
                this.seleccion.push(this.seleccionres[i])
              }
            }
          }
        }
      }
    },
    diac (val) {
      if (val) {
        this.diad = ''
        if (val === 1) {
          this.seleccion.sort(function (a, b) {
            return a.diaCredito - b.diaCredito
          })
        }
        if (val === 2) {
          this.seleccion.sort(function (a, b) {
            return b.diaCredito - a.diaCredito
          })
        }
      }
    },
    diad (val) {
      if (val) {
        this.diac = ''
        if (val === 1) {
          this.seleccion.sort(function (a, b) {
            return a.diaDespacho - b.diaDespacho
          })
        }
        if (val === 2) {
          this.seleccion.sort(function (a, b) {
            return b.diaDespacho - a.diaDespacho
          })
        }
      }
    },
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    this.initialize()
    // this.permisosRuta = this.$store.state.empresa[0].permisos.find(
    //   permiso => permiso.ruta == "Producto"
    // );
  },

  methods: {
    initialize () {
      this.listarOrdenes()
      this.cargarProductos()
    },

    formato (fecha) {
      return this.$moment(fecha).format('YYYY-MM-DD, HH:mm')
    },

    listarOrdenes () {
      Api.get('/ordenesDeCotizacion')
        .then(res => {
          this.ordenes = res.data
          this.ordenes.map(data => {
            data.fechaEmision = this.formato(data.fechaEmision)
          })
          this.loading = false
        })
        .catch(e => {
          console.log('error' + e)
          this.permissDenied(e.response.status)
        })
    },

    llenarProductosSelect () {
      this.editedItem.selecProductosHijo = []
      Api.get('producto').then(res => {
        res.data.map(producto => {
          this.editedItem.selecProductosHijo.push({
            value: producto._id,
            text: producto.descripcion,
            cod: producto.nombre
          })
        })
      })
    },

    cargarProductos (data) {
      this.editedItem.productos = []
      this.llenarProductosSelect()
    },

    validarCrear () {
      return true
      // return this.permisosRuta.accion.includes("Crear");
    },

    validarModificar () {
      return true
      // return this.permisosRuta.accion.includes("Modificar");
    },

    validarEliminar () {
      return true
      // return this.permisosRuta.accion.includes("Eliminar");
    },

    editItem (item, bool) {
      item.selecProductosHijo = []
      this.editedIndex = this.ordenes.indexOf(item)
      this.editedItem = Object.assign({}, item)
      if (item.cot) {
        this.seleccion = item.cot
        this.seleccionres = item.cot
      }
      this.dialog = true
      this.read = bool
      this.edicion = bool
      if (this.seleccion && item.productos && item.productos.length > 0) {
        this.prodArray.push({ value: 1, text: 'Todos' })
        for (let i = 0; i < item.productos.length; i++) {
          this.prodArray.push({ value: item.productos[i].idProducto._id, text: item.productos[i].idProducto.descripcion })
        }
      }
      if (!this.read) {
        this.llenarProductosSelect()
        let aux = this.editedItem.selecProductosHijo.slice()
        aux.map((producto, pos) => {
          if (
            this.editedItem.productos.some(
              igual => igual.idProducto._id === producto.value
            )
          ) {
            this.editedItem.selecProductosHijo.splice(
              this.editedItem.selecProductosHijo.indexOf(producto),
              1
            )
          }
        })
      }
    },

    deleteItem (item) {
      const index = this.ordenes.indexOf(item)
      this.$swal({
        icon: 'warning',
        title: '¿Seguro que quieres borrar?',
        text: 'No podras revertir esto',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, borrar',
        cancelButtonText: 'cancelar'
      }).then(result => {
        if (result.value) {
          this.$swal('Borrado!', 'Su registro fue borrado.', 'success')
          this.ordenes.splice(index, 1)
          Api.delete('/ordenesDeCotizacion/' + item._id).then(response => {
          })
        }
      })
    },

    close () {
      this.dialog = false
      this.edicion = false
      this.diac = ''
      this.diad = ''
      this.prod = ''
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.editedItem.productos = []
        this.read = false
        this.llenarProductosSelect()
      }, 300)
    },

    validarCampos () {
      if (this.editedItem.idProveedor === '') {
        this.$swal({
          icon: 'error',
          title: 'Formulario incompleto',
          text: 'Por favor llene todos los campos para continuar'
        })
        return true
      }
      return false
    },

    validaProductos () {
      if (this.editedItem.productos.length <= 0) {
        this.$swal({
          icon: 'error',
          title: 'No existen productos cargados a la orden',
          text: 'Carge productos para emitir la Orden de Compra'
        })
        return true
      }
      return false
    },

    permissDenied (status) {
      if (status === '403') {
        this.$swal({
          icon: 'error',
          title: 'Permiso denegado',
          text: 'No tiene pemisos suficientes para ver esta página',
          allowOutsideClick: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ok',
          onAfterClose: () => {
            window.location.href = '/home'
          }
        })
      }
    },

    save () {
      if (!this.validarCampos() && !this.validaProductos()) {
        this.$swal({
          title: 'Cargando...',
          html: 'Esperando respuesta del servidor',
          allowOutsideClick: false,
          onBeforeOpen: () => {
            this.$swal.showLoading()
          }
        })
        if (this.editedIndex > -1) {
          Api.put('ordenesDeCotizacion', this.editedItem)
            .then(response => {
              this.$swal({
                icon: 'success',
                title: 'Modificacion exitosa',
                text: 'Todos los cambios han sido efectuados'
              })
              this.listarOrdenes()
              this.close()
            })
            .catch(e => {
              this.$swal({
                icon: 'error',
                title: 'Error al modificar',
                text: 'Por favor, verifique los datos e intente de nuevo'
              })
            })

          Object.assign(this.ordenes[this.editedIndex], this.editedItem)
        } else {
          this.editedItem.idUsuario = this.$store.state.usuario._id
          Api.post('ordenesDeCotizacion', this.editedItem)
            .then(response => {
              this.$swal({
                icon: 'success',
                title: 'Inclusion exitosa',
                text: 'Todos los datos han sido guardados'
              })
              this.ordenes.push(response.data)
              this.listarOrdenes()
              this.close()
            })
            .catch(e => {
              console.log('error' + e)
              this.$swal({
                icon: 'error',
                title: 'Error al guardar',
                text: 'Por favor, verifique los datos e intente de nuevo'
              })
            })
        }
      }
    }
  }
}
</script>
<style lang='scss'>
@import '~@/assets/scss/ordencotizacion.scss';
</style>
